// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__7uhM7","text":"style_text__1JvtU"};